import React, { memo } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { useBenefitsSectionStyles } from './BenefitsSection.styles';
import { urlLang } from '../../helpers/langHelper';
import { CustomPoint } from './CustomPoint/CustomPoint';
import { Grid } from '@material-ui/core';

export const BenefitsSection = memo(() => {
    const { t } = useTranslation();
    const classes = useBenefitsSectionStyles();
    const imgPath = `${process.env.PUBLIC_URL}/assets/landing2020`;
    const quoteFr = `${imgPath}/quote-fr.png`;
    const quoteFrAlt = 'Jules-Henri Gavetti ';
    const quote = `${imgPath}/quote-image.png`;
    const quoteAlt = 'Manuel Gerbolés ';
    const quoteSeparator = `${imgPath}/quote-separator.png`;
    const lang = urlLang();
    const isFrLang = lang === 'fr';
    const axaLogo = `${imgPath}/axa-logo.png`;
    const axaLogoAlt = 'AXA logo';
    const europeLogo = `${imgPath}/europe-logo.jpeg`;
    const europeLogoAlt = 'Europe logo';
    const axaLogoTpl = () => (
        <img className={classes.trustLogo} src={axaLogo} alt={axaLogoAlt} data-signa="auth-register-axa-logo" />
    );
    const standardLogos = () => {
        const fenieLogo = `${imgPath}/fenie-logo.png`;
        const fenieLogoAlt = 'Fenie logo';
        const cuatrecasasLogo = `${imgPath}/cuatrecasas-logo.png`;
        const cuatrecasasLogoAlt = 'Cuatrecasas logo';
        const accionaLogo = `${imgPath}/acciona-logo.png`;
        const accionaLogoAlt = 'Acciona logo';
        return (
            <>
                {axaLogoTpl()}
                <img
                    className={classes.trustLogo}
                    src={fenieLogo}
                    alt={fenieLogoAlt}
                    data-signa="auth-register-fenie-logo"
                />
                <img
                    className={classes.trustLogo}
                    src={cuatrecasasLogo}
                    alt={cuatrecasasLogoAlt}
                    data-signa="auth-register-cuatrecasas-logo"
                />
                <img
                    className={classes.trustLogo}
                    src={accionaLogo}
                    alt={accionaLogoAlt}
                    data-signa="auth-register-acciona-logo"
                />
            </>
        );
    };
    const frenchLogos = () => {
        const decathlonLogo = `${imgPath}/decathlon-logo.png`;
        const decathlonLogoAlt = 'Decathlon logo';
        const manpowerLogo = `${imgPath}/manpower-logo.png`;
        const manpowerLogoAlt = 'Manpower logo';
        const oranginaLogo = `${imgPath}/orangina-france-logo.png`;
        const oranginaLogoAlt = 'Orangina Suntory France logo';

        return (
            <>
                {axaLogoTpl()}
                <img
                    className={classes.trustLogo}
                    src={decathlonLogo}
                    alt={decathlonLogoAlt}
                    data-signa="auth-register-decathlon-logo"
                />
                <img
                    className={classes.trustLogo}
                    src={manpowerLogo}
                    alt={manpowerLogoAlt}
                    data-signa="auth-register-manpower-logo"
                />
                <img
                    className={classes.trustLogo}
                    src={oranginaLogo}
                    alt={oranginaLogoAlt}
                    data-signa="auth-register-orangina-logo"
                />
            </>
        );
    };
    return (
        <section data-signa="auth-register-section" className={classes.section}>
            <Grid container className={classes.mask}>
                <Grid item className={classes.benefitsContainer}>
                    <h2 className={classes.title} data-signa="auth-register-title">
                        {t('auth.register.freetrial.benefits_title')}
                    </h2>

                    <div className={classes.list} data-signa="auth-register-list">
                        <div className={classes.listColumn} data-signa="auth-register-list-column-1">
                            <CustomPoint
                                data-signa="auth-register-point-1"
                                label={t('auth.freetrial.benefit_points_1')}
                                name="point1"
                            />
                            <CustomPoint
                                data-signa="auth-register-point-2"
                                label={t('auth.freetrial.benefit_points_2')}
                                name="point2"
                            />
                            <CustomPoint
                                data-signa="auth-register-point-3"
                                label={t('auth.freetrial.benefit_points_3')}
                                name="point3"
                            />
                        </div>
                        <div className={classes.listColumn} data-signa="auth-register-list-column-2">
                            <CustomPoint
                                data-signa="auth-register-point-4"
                                label={t('auth.freetrial.benefit_points_4')}
                                name="point4"
                            />
                            <CustomPoint
                                data-signa="auth-register-point-5"
                                label={t('auth.freetrial.benefit_points_5')}
                                name="point5"
                            />
                            <CustomPoint
                                data-signa="auth-register-point-6"
                                label={t('auth.freetrial.benefit_points_6')}
                                name="point6"
                            />
                        </div>
                    </div>
                    <div data-signa="auth-register-quote" className={classes.quote}>
                        {isFrLang ? (
                            <img className={classes.quoteImage} src={quoteFr} alt={quoteFrAlt} />
                        ) : (
                            <img className={classes.quoteImage} src={quote} alt={quoteAlt} />
                        )}

                        <img
                            data-signa="auth-register-quote-separator"
                            className={classes.quoteSeparator}
                            src={quoteSeparator}
                            alt="Quote "
                        />
                        <div data-signa="auth-register-quote-description" className={classes.quoteDescription}>
                            <p>{t('auth.freetrial.benefit_quote_text')}</p>
                            <small className="benefits-quote-description-small">
                                <b>{t('auth.freetrial.benefit_quote_name')}</b>
                            </small>

                            <small className="benefits-quote-description-small">
                                <Trans i18nKey={'auth.freetrial.benefit_quote_position'}></Trans>
                            </small>
                        </div>
                    </div>
                    <div className={classes.trust}>
                        <p data-signa="auth-register-trust-text" className={classes.trustText}>
                            {t('auth.freetrial.benefit_trust_text')}
                        </p>
                        <div data-signa="auth-register-trust-logos" className={classes.trustLogos}>
                            {isFrLang ? frenchLogos() : standardLogos()}
                        </div>
                        <div data-signa="auth-register-trust-europe" className={classes.trustEurope}>
                            <p data-signa="auth-register-trust-europe-text" className={classes.trustEuropeText}>
                                {t('auth.freetrial.benefit_trust_europe')}
                            </p>
                            <img
                                data-signa="auth-register-trust-europe-logo"
                                className={classes.trustEuropeLogo}
                                src={europeLogo}
                                alt={europeLogoAlt}
                            />
                        </div>
                    </div>
                </Grid>
            </Grid>
        </section>
    );
});
